import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';
import svgSrc from 'assets/meta-business-partner.svg';

export const MetaBadge = ({
  className,
  style: styleFromProps,
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <figure style={style} className={classNames(className)} onClick={onClick}>
      <img src={svgSrc} alt="Meta Business Partner" />
    </figure>
  );
};
